import React from "react";

const About: React.FC = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>O nás</h1>
      <p>Jsme jen majitelé malé želvy zelenavé, kteří udělali tu chybu, že uvěřili recenzím na Google.</p>
      <p>
        Nevybíráme žádné peníze a jiné příspěvky. 
      </p>
      <p>
        Naším cílem je pouze aby se malým želvám nestávalo to co té naší, tedy nevhodné zacházení ze strany prodejce. A to konkrétně ze strany pana Junka z euzelva.cz.
      </p>
      <p>
        Je to naše jediná zkušest. Pokud máte svou, i s jiným prodejcem, neváhejte se na nás obrátit přes <a href="/kontakt">kontaktní email</a>.
      </p>
    </div>
  );
};

export default About;
